/* ### CONSTANTS ### */

import { IQueryMetaDataType } from "../../../../../boilerplate/redux/types/IQueryMetaDataType";
import { IApiErrorType } from "../../../../types/BaseTypes";

export const CONTENT_FRAGMENT_FETCH_ENTRIES = '@BasePipeline/contentFragmentReducer_FETCH_ENTRIES';
export const CONTENT_FRAGMENT_ADD_ENTRIES = '@BasePipeline/contentFragmentReducer_ADD_ENTRIES';
export const CONTENT_FRAGMENT_ADD_ENTRY = '@BasePipeline/contentFragmentReducer_ADD_ENTRY';

export const CONTENT_FRAGMENT_SET_ERRORS   = '@BasePipeline/contentFragmentReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function addContentFragmentEntries (queryKey: string, entries: [], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: CONTENT_FRAGMENT_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function addContentFragmentEntry (queryKey: string, entry: {}, metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: CONTENT_FRAGMENT_ADD_ENTRY,
		queryKey,
		entry,
		metaData,
	};
}

export function setContentFragmentErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: CONTENT_FRAGMENT_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
